import LoginForm from "./LoginForm.vue";
import AgentLoginForm from "./AgentLoginForm.vue";
import { createApp } from "vue";
import ApiService from "@/services/apiService";

let loginAppContainer = document.getElementById("idLoginForm");
if(loginAppContainer){
    // App laden mit Daten aus dem data-Attribut - der Propname muss im Element über props definiert sein
    // const data = loginAppContainer.dataset["name ohne data-"];
    // const app = createApp(Login, {propname: data});
    
    ApiService.create();
    const app= createApp(LoginForm, { container:loginAppContainer });

    // Devtools aktivieren
    app.config.devtools = true;

    app.mount(loginAppContainer);
}
else {
    loginAppContainer = document.getElementById("idAgentLoginForm");

    if(loginAppContainer){
        
        ApiService.create();    
        const app= createApp(AgentLoginForm, { container:loginAppContainer });    
        app.mount(loginAppContainer);
    }    
}

